import type { INavigationItem } from '@/types/sidebar'

export const chatNavigation: INavigationItem[] = []

export const chatNavigationGroups = {
  recent_chats: {
    label: 'Recent Chats',
  },
}
